import axiosInstance from "../helpers/axiosInstance"

export const fetchNaturaAllowedWarehouses = async () => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/natura-replenishments/warehouses`)              
  return res.data
}

/**
 * Creates a new product in the system for Natura replenishments
 * @param {Object} productData - The product data to create
 * @param {string} productData.sku - Product SKU
 * @param {string} productData.name - Product name
 * @param {string} productData.description - Product description
 * @param {number} productData.weight - Product weight in grams
 * @param {number} productData.price - Product price
 * @param {string} productData.bar_code - Product barcode/UPC
 * @returns {Promise<Object>} Promise resolving to the created product response
 */
export const createNaturaProduct = async (productData) => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/natura-replenishments/create-product`, productData)
  return res.data
}

/**
 * Saves natura replenishment data (mockup service)
 * @param {Object} replenishmentData - The replenishment data to save
 * @param {number} replenishmentData.warehouse_id - The warehouse ID
 * @param {string} replenishmentData.store_id - The store ID
 * @param {string[]} replenishmentData.items - Array of SKU strings
 * @returns {Promise<Object>} Promise resolving to the saved replenishment response
 */
export const saveNaturaReplenishment = async (replenishmentData) => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/natura-replenishments`, {
    warehouse_id: replenishmentData.warehouse_id,
    // store_id: replenishmentData.store_id ?? -1,
    items: replenishmentData.items
  })
  return res.data
}

/**
 * Busca lista de NCMs disponíveis
 * Processa a resposta da API e retorna apenas as informações necessárias
 * @returns {Promise<Object>} Lista de NCMs tratada
 */
export const fetchNaturaNCMList = async () => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/natura-replenishments/ncm-codes`)
  
  // Processa a resposta da API que vem no formato complexo
  const processedNCMList = Object.keys(res.data).map(ncmCode => ({
    code: ncmCode,
    description: res.data[ncmCode].description
  }))

  return {
    data: processedNCMList,
    message: 'Lista de NCMs carregada com sucesso',
    total: processedNCMList.length
  }
}